import { CardHeader, Form, Input, InputGroup } from 'reactstrap'
import { Pixelstrap } from '../../../../Utils/Constants'
import { Btn } from '../../../../AbstractElements'
import { Search } from 'react-feather'

const SearchInput = () => {
  return (
    <CardHeader>
      <Form className="theme-form">
        <InputGroup className=" m-0 flex-nowrap">
          <Input className="form-control-plaintext" type="search" placeholder={Pixelstrap} />
          <Btn color="primary"><Search className="search-icon" /></Btn>
        </InputGroup>
      </Form>
    </CardHeader>
  )
}

export default SearchInput